import { module } from 'angular';
import App from '../../../app';

class SCR0502Controller {
	
	constructor ($scope, $uibModalInstance, $timeout, httpService, gridService, codeService, popupService, data){
		this.$scope = $scope;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.codeService = codeService;
		this.data = data;
		
		this.initWindow(1200, 680);
		this.initText();
		this.initSearch();
		this.initSelect();
		this.initCode();
		
		this.$timeout(() => {
			this.initMsgGridOption();
			this.getMsglayoutList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width, height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageMsg'));
	}
	
	initSearch(){
		this.searchParam = {};
		if($.cookie('lvCd')){
			let lvCdList = $.cookie('lvCd').split('/');
			this.searchParam.lv1Cd = lvCdList[0];
			this.searchParam.lv2Cd = lvCdList[1];
			this.searchParam.lv3Cd = lvCdList[2];
		}
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
		this.pageNumber = 1;
		this.selected = [];
	}
	
	initCode(){
		this.msgTypeList = this.codeService.getCodesByCdIdFromMem('MSG_TYPE');
		this.chlDscdList = this.codeService.getCodesByCdIdFromMem('CHL_DSCD');
		this.tranDscdList = this.codeService.getCodesByCdIdFromMem('TRAN_DSCD');
		this.workStatusList = this.codeService.getCodesByCdIdFromMem('WORK_STATUS_CD').filter(v => v.cdVal !== 'DEPLOY_COMP');
	}

	initMsgGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({showAll:false});
		if(this.data.multiSelect === false){
			this.gridView.setCheckBar({visible: false});
		}
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
            {fieldName: "lv1Cd"}, {fieldName: "lv2Cd"}, {fieldName: "lv3Cd"},
            {fieldName: "msgLayoutId"}, {fieldName: "msgNm"}, {fieldName: "msgDataVal"}, {fieldName: "extrnlBizNm"},
            {fieldName: "msgVersion"}, {fieldName: "regManId"},
            {fieldName: "chlDscd"}, {fieldName: "trxDscd"}, {fieldName: "msgDscd"},
    		{fieldName: "workStatusCd"}, {fieldName: "regDttm"},
            {
            	fieldName: "lvCds",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return values[fieldNames.indexOf('lv1Cd')] + '/' + values[fieldNames.indexOf('lv2Cd')] + '/' + values[fieldNames.indexOf('lv3Cd')];
        		}
            }, 
            {
            	fieldName: "chlDscdTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.codeService.getCodeValNm('CHL_DSCD', values[fieldNames.indexOf('chlDscd')]);
        		}
        	}, 
            {
        		fieldName: "trxDscdTxt",
        		calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.codeService.getCodeValNm('TRAN_DSCD', values[fieldNames.indexOf('trxDscd')]);
        		}
			}, 
            {
            	fieldName: "msgDscdTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.codeService.getCodeValNm('MSG_TYPE', values[fieldNames.indexOf('msgDscd')]);
        		}
        	}, 
            {
            	fieldName: "workStatusCdTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.codeService.getCodeValNm('WORK_STATUS_CD', values[fieldNames.indexOf('workStatusCd')]);
        		}
    		}, 
            {
            	fieldName: "regDttmTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		const regDttm = values[fieldNames.indexOf('regDttm')];
					const yy = regDttm.substring(0,4);
					const mm = regDttm.substring(4,6);
					const dd = regDttm.substring(6,8);
				
					return yy+"/"+mm+"/"+dd;
        		}
    		}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "msgLayoutId", fieldName: "msgLayoutId", header : { text: this.text.msgLayoutId }, width: 160 },
			{ name: "msgNm", fieldName: "msgNm", header : { text: this.text.msgName }, width: 160, styles: { textWrap: 'ellipse' }  },
			{ name: "chlDscd", fieldName: "chlDscdTxt", header : { text: this.text.chlDscd }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "trxDscd", fieldName: "trxDscdTxt", header : { text: this.text.trxDscd }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "msgDataVal", fieldName: "msgDataVal", header : { text: this.text.msgDataVal + '/' + this.text.dtoNm }, width: 100, styles: { textWrap: 'ellipse' } },
			{ name: "msgDscd", fieldName: "msgDscdTxt", header : { text: this.text.msgType }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "msgVersion", fieldName: "msgVersion", header : { text: this.text.msgVersion }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "workStatusCd", fieldName: "workStatusCdTxt", header : { text: this.text.workStatusCd }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "regManId", fieldName: "regManId", header : { text: this.text.msgRegister }, width: 70, styles: { textAlignment: 'center' } },
			{ name: "regDttm", fieldName: "regDttmTxt", header : { text: this.text.msgRegisterDt }, width: 80, styles: { textAlignment: 'center' } }	
		]);
		
		this.gridView.onItemChecked = (grid, itemIndex, checked) => {
			let msgLayoutId = this.gridView.getValues(itemIndex)['msgLayoutId'];
			
			if(checked){
				this.selected.push(msgLayoutId);
			}else{
				this.selected.splice(this.selected.indexOf(msgLayoutId), 1);
			}
		};
		
		/*this.gridView.onItemAllChecked = (grid) => {
			let startIdx = 0;
			let endIdx = 10;
			
			if(this.gridView.isAllChecked()){
				for(var idx = startIdx; idx <endIdx; idx++){
					let msgLayoutId = this.gridView.getValues(idx)['msgLayoutId'];
					this.selected.push(msgLayoutId);
				}
			}else{
				for(var idx = startIdx; idx <endIdx; idx++){
					let msgLayoutId = this.gridView.getValues(idx)['msgLayoutId'];
					this.selected.splice(this.selected.indexOf(msgLayoutId), 1);
				}
			}
		};*/
		
		this.gridView.onDataCellClicked = (grid, cell) => {
			if(this.data.multiSelect === false){
				this.selected = [this.gridView.getValues(cell.itemIndex)['msgLayoutId']];
			}
		};
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.selected = [this.gridView.getValues(cell.itemIndex)['msgLayoutId']];
			this.closeModal(true);
		};
	
	}
	
	getMsglayoutList() {
		let url = `/msglayouts?pageNumber=1&pageSize=99999`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			this.msglayoutbsOutList = data.msglayoutbsOutList;
			this.recordsCount = data.totalCnt;
			
			this.pageNumber = 1;
			this.$scope.$broadcast(`resetPage`, this.pageNumber);
			this.pageBtnClick(1);
		});
	}
	
	setPageConts() {
		let startIdx = (this.pageNumber - 1) * 10;
		let endIdx = this.pageNumber * 10;

		this.dataProvider.setRows(this.msglayoutbsOutList.slice(startIdx, endIdx));
		
		this.changedPage = true;
		this.selected.map((msgLayoutId) => {
			let itemIdx = this.gridView.searchItem({fields : ['msgLayoutId'], values : [msgLayoutId]});
			this.gridView.checkItem(itemIdx, true, false, false);
		});
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getMsglayoutList();
	}
	
	search(){
		this.getMsglayoutList();
	}
	
	blur($event){
		$event.target.blur();
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.setPageConts();
	}
	
	closeModal(isOk){
		if(isOk){
			if(this.selected.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.getMsglayout(this.selected);
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	getMsglayout(selectionList) {
		this.httpService.post(`/msglayoutslist`, selectionList).then(res => {
			this.$uibModalInstance.close(res.msglayoutbsDtoList);
		});
	}
	
	openApplicationCodeModalForSearchParam(){
		this.popupService.openModal('SCR1402')
						 .then((codes) => {
							this.searchParam.lv1Cd = "";
							this.searchParam.lv2Cd = "";
							this.searchParam.lv3Cd = "";
							
							codes.map((code, index) =>{
								this.searchParam[`lv${index +1}Cd`] = code.appCd;
							});
						 })
						 .catch(()=>{});
	}
	
	openRegManPopup(){
		this.popupService.openModal('SCR0102')
						 .then(user => this.searchParam.regManId = user.userId)
						 .catch(()=>{});
	}
	
	getLvCd(intrfccoms) {
		let lvCd = '';
		
		if(intrfccoms) {
			if(intrfccoms.lv1Cd) {
				lvCd = intrfccoms.lv1Cd;
			}
			
			if(intrfccoms.lv2Cd) {
				lvCd += '/' + intrfccoms.lv2Cd;
			}
			
			if(intrfccoms.lv3Cd) {
				lvCd += '/' + intrfccoms.lv3Cd;
			}	
		}
		
		return lvCd;
	}
	
}

module(App.name).controller('SCR0502Controller', SCR0502Controller);


// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0502/SCR0502.controller.js